<!--  -->
<template>
  <div class="cc" style="">
    <div class="logo-container" >
      <svg class="logo" aria-hidden="true">
        <use xlink:href="#icon-logo" />
      </svg>
    </div>
    <el-scrollbar style="box-sizing: border-box; flex: 1;width: 100%;">
      <sidebar-menu></sidebar-menu>
    </el-scrollbar>
  </div>
</template>

<script setup>
import {} from 'vue'
import SidebarMenu from './SidebarMenu'

// const logoHeight = 160000
</script>

<style lang="scss" scoped>
.cc {
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo-container {
    margin-top: 56px;
    width: 120px;
    height: 120px;
    margin-bottom: 70px;
    box-sizing: border-box;
    .logo {
      width: 100%;
      height: 100%;
      fill: #fff;
    }
  }
}
</style>
